/**
 * CurrentOrganizationCardMeta
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Card } from 'semantic-ui-react';

// Selectors
import { selectCurrentOrganizationId } from '../../../../../../../../services/currentOrganizationId/selectors';

interface Props {
    organizationId: string;
    currentOrganizationId: number;
}

export class CurrentOrganizationCardMeta extends React.PureComponent<Props> {
    render() {
        const { organizationId, currentOrganizationId } = this.props;
        if (organizationId !== currentOrganizationId) return null;

        return <Card.Meta>Selected</Card.Meta>;
    }
}
const mapStateToProps = createStructuredSelector({
    currentOrganizationId: selectCurrentOrganizationId
});

export default connect(mapStateToProps)(CurrentOrganizationCardMeta);
